export * from './baseline';
export * from './mapbox';
export * from './general';
export * from './dates';
export const APP_NAME = 'gpr';
export const FEEDBACK_EMAIL = 'support@oceanxenergy.com';
export const STORE_VERSION = 1.3;

export const FONT_FAMILY = ['Roboto', 'helvetica', 'Arial', 'sans-serif'].join(',');

export const APP_PAGES = {
  DASHBOARD: '/',
  RIG_PAGE: '/rig',
  BASELINE_COMP: '/baseline-comp',
  REPORTS: '/reports'
};

export const TIME_PERIOD_TABS = {
  DATA_PICKER: 0,
  SAVE_TIME: 1,
  WELL: 2
};
